/**
 * Очередь на одно соединение.
 *
 * И в Tauri, и в браузере база за драйвером одна, а транзакция в SQLite —
 * состояние этого соединения: два параллельных `begin` схлопнулись бы в одну
 * транзакцию, и откат первой утащил бы правки второй. Поэтому операции,
 * которым нужна монопольность, выстраиваются в очередь.
 */
export class AsyncMutex {
  #tail: Promise<unknown> = Promise.resolve()

  async run<T>(operation: () => Promise<T>): Promise<T> {
    // Ждём хвост очереди, но не даём чужой ошибке обрушить свою операцию.
    const previous = this.#tail.catch(() => undefined)
    const current = previous.then(operation)
    this.#tail = current.catch(() => undefined)
    return current
  }
}
